import React from "react";
import PaymentSourceComponent from "../features/PaymentSource/main/PaymentSource";

const PaymentSource = () => {
  return (
    <>
      <PaymentSourceComponent />
    </>
  );
};

export default PaymentSource;
